import {
    Button,
    Card,
    CardContent,
    Grid,
    Tooltip,
} from '@mui/material';
import CustomisedUploadFile from '../uploader/uploadFile';
import { IUploadFile } from '../uploader/IUploadFile';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ExtendedFile, ICardUpload } from './ICardUpload';
import { useEffect, useState } from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useMutation, useQueryClient } from 'react-query';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CustomisedLoadFile from '../loadFile/loadFile';
import ConfirmDeleteModal from '../modal/confirmDeleteModal';

export default function CustomisedCardMultiLoad({
    title,
    comment,
    fileSelected,
    documentId,
    setDelImage,
    setChildValue,
    fileArray,
    serviceName,
    serviceRequestObj,
    rejected,
    setFileUrlDel,
    checkBySetad
}: ICardUpload) {
    const [openTooltip, setOpenTooltipValue] = useState(null);
    const [openVerifyModal, setOpenVerifyModal] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const queryClient = useQueryClient();
    const toggleClick = (index: any) => {
        setOpenTooltipValue(openTooltip === index ? null : index);
    };
    function deleteImage() {
        setOpenVerifyModal(true);
    }
    useEffect(() => {
        if (confirm === true) {
            if (serviceRequestObj !== null && serviceRequestObj !== undefined) {
                serviceRequestObj.fileId = fileArray?.fileId;
                RemoveDocumentMutate(serviceRequestObj);
                setFileUrlDel(fileArray?.fileUrl);
            }
        }
    }, [confirm])
    const { mutate: RemoveDocumentMutate } = useMutation(serviceName, {
        onSuccess: (data: boolean) => {
            if (data) {
                setDelImage(data!);
                setOpenVerifyModal(false);
                setConfirm(false);
            }
        },
    });
    let url = fileSelected + '/true';
    return (

        <Grid container style={{ alignItems: 'center' }}>
            <Grid item xs={12} style={{
                paddingBottom: '20px', height: '24vh', minHeight: '20px',
                maxHeight: '229px', paddingTop: '20px'
            }} >
                <>
                    <div className="imageUpload" style={{ borderBottom: 'none' }}>
                        <a href={url!} target="_blank" style={{ objectFit: 'cover' }}>
                            <img
                                style={{
                                    // width: '100%',
                                    // objectFit: 'contain',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    maxHeight: '100%',
                                    height: '100%'
                                }}
                                className="text-center block m-auto"
                                src={fileSelected ? fileSelected : '/images/login.svg'}
                            />
                        </a>
                    </div>
                    <div style={{
                        backgroundColor: 'black',
                        opacity: '70%',
                        marginTop: '-6.5vh',
                        borderBottomRightRadius: '5px',
                        borderBottomLeftRadius: '5px',
                        height: '5vh',
                        bottom: '-0.4vh',
                        position: 'relative'
                    }}>
                        <Grid container xs={12} style={{
                            height: '100%',
                            alignContent: 'center'
                        }}>
                            <Grid item xs={10} style={{ paddingRight: '1vw', alignContent: 'center' }}>

                                <p style={{ color: '#fff' }}>{fileArray.fileName.slice(0, 10) + '...'}</p>
                            </Grid>
                            {
                                (rejected === true || rejected === undefined) || checkBySetad === false ?
                                    <>
                                        <Grid item xs={2} style={{
                                            textAlign: 'end',
                                            paddingLeft: '1vw'
                                        }}
                                        >
                                            <Button onClick={() => deleteImage()} style={{ justifyContent: 'right' }}>
                                                <DeleteOutlineIcon style={{ color: '#fff' }} />
                                            </Button>
                                        </Grid>
                                    </> : ""
                            }

                        </Grid>
                    </div>
                </>
                {/* <CustomisedLoadFile fileUrl={fileSelected} isMulti={true} fileName={fileArray.fileName} /> */}
            </Grid>
            <ConfirmDeleteModal text={"آیا از حذف این مدرک اطمینان داید؟"}
                buttonTitle={'حذف'}
                delButton={true}
                openModal={openVerifyModal}
                setOpenVerifyModal={setOpenVerifyModal}
                setConfirm={setConfirm}
            />
        </Grid >

    );
}
